/* eslint-disable  */
//@ts-nocheck

import auth from '@client/components/auth';
import { useGetArchivedWorkoutsQuery } from '../../../../generated/graphql';
import { browserHistory } from 'react-router';
import { WorkoutList } from './components/WorkoutList';
import { WorkoutsPage } from './components/WorkoutsPage';

export function ArchivedWorkoutsPage(props) {
  const influencerId = props.params.influencerId
    ? props.params.influencerId
    : auth.getUser().influencerId;

  const url = new URL(window.location.href);
  const shouldRefresh = url.searchParams.get('refresh');

  const {
    loading: isLoading,
    data,
    refetch,
  } = useGetArchivedWorkoutsQuery({
    variables: { id: parseInt(influencerId) },
    skip: !influencerId,
    fetchPolicy: shouldRefresh ? 'network-only' : 'cache-first',
    onCompleted: () => {
      if (shouldRefresh) {
        url.searchParams.delete('refresh');
        browserHistory.replace(url.href);
      }
    },
  });

  const doesNotHaveData = !data?.creator;

  const workouts = doesNotHaveData
    ? []
    : [...data.creator.archivedWorkouts].sort(descSortByDate('archivedAt'));

  return (
    <WorkoutsPage
      isLoading={isLoading}
      creator={data ? data.creator : { id: influencerId }}
    >
      <WorkoutList
        type="archived"
        refreshWorkouts={refetch}
        workouts={workouts}
        influencerId={influencerId}
      />
    </WorkoutsPage>
  );
}

function descSortByDate(prop: string) {
  return (a, b) => new Date(b[prop]).getTime() - new Date(a[prop]).getTime();
}
